<form [formGroup]="formGroup">
  <div class="delivery-promise-deliverytime-container" [formGroupName]="'deliveryPromiseDeliveryTimeSettings'">
    @if (shippingMethodCategory !== 'local') {
      <span class="processing-text">Processing</span>
      <div class="flex-col" style="gap: unset; margin-bottom: 5px">
        <div class="flex-row">
          <pdq-slide-toggle
            style="display: grid"
            formControlName="useMetafieldProcessingTime"
            [label]="'Use metafield processing time'"
            [subtext]="'Define product processing time in Shopify – PDQ will use the highest value.'">
            <pdq-link
              [external]="true"
              label="Learn More"
              size="small"
              [url]="'https://support.prettydamnquick.com/en/articles/11155420-processing-time-in-delivery-promise'">
            </pdq-link>
          </pdq-slide-toggle>
        </div>
      </div>

      @if (formGroup.get('deliveryPromiseDeliveryTimeSettings.useMetafieldProcessingTime')?.value) {
        <div class="flex-row">
          <pdq-input
            width="313"
            widthSize="auto"
            formControlName="metafieldProcessingTime"
            placeholder="pdq.processing_time"
            label="Map Shopify Metafield"
            [invalid]="formGroup.errors?.delivery_promise_metafield_processingtime_missmatch"
            [invalidMsg]="formGroup.errors?.delivery_promise_metafield_processingtime_missmatch_msg"
            [required]="false">
          </pdq-input>
          <pdq-input-arrows
            width="275"
            widthSize="auto"
            formControlName="metafieldProcessingTimeFallback"
            placeholder="Enter # of days"
            label="Fallback value"
            [required]="false"
            [min]="0">
          </pdq-input-arrows>
        </div>
        @if (formGroup.errors?.delivery_promise_metafield_processingtime_fallback_missmatch) {
          <span class="inline-error">
            *{{ formGroup.errors?.delivery_promise_metafield_processingtime_fallback_missmatch_msg }}
          </span>
        }
      }

      @if (formGroup.get('deliveryPromiseDeliveryTimeSettings.useMetafieldProcessingTime')?.value) {
        <span class="transit-text" style="margin-top: var(--margin-24); display: block">Combined with metafield</span>
      }
      <div class="flex-row">
        <pdq-input-arrows
          [tooltip]="runningABTest ? 'Disabled due running A/B test' : ''"
          tooltipIconColor="var(--warning-default)"
          width="275"
          widthSize="auto"
          [disabled]="runningABTest"
          placeholder="{{ getDeliveryPromiseInputPlaceholder() }}"
          formControlName="minProcessingDays"
          label="Min processing days"
          [required]="false"
          [min]="0">
        </pdq-input-arrows>
        <pdq-input-arrows
          [tooltip]="runningABTest ? 'Disabled due running A/B test' : ''"
          tooltipIconColor="var(--warning-default)"
          width="275"
          widthSize="auto"
          [disabled]="runningABTest"
          placeholder="Enter max # of {{ getDeliveryPromiseDisplayTimeString() }}"
          formControlName="maxProcessingDays"
          label="Max processing days"
          [required]="false"
          [min]="0">
        </pdq-input-arrows>
      </div>
      @if (formGroup.errors?.delivery_promise_processingtime_missmatch) {
        <span class="inline-error"> *{{ formGroup.errors?.delivery_promise_processingtime_missmatch_msg }} </span>
      }
      @if (
        formGroup.get('estimatedTimeConversions')?.value === 'manual' &&
        shippingMethodCategory !== ShippingMethod.STORE_PICK_UP
      ) {
        <div class="transit-text" style="margin-top: 20px">Transit</div>
        <div class="flex-row">
          <pdq-input-arrows
            [tooltip]="runningABTest ? 'Disabled due running A/B test' : ''"
            tooltipIconColor="var(--warning-default)"
            width="275"
            widthSize="auto"
            [disabled]="runningABTest"
            placeholder="{{ getDeliveryPromiseInputPlaceholder() }}"
            formControlName="minTransitDays"
            label="Min transit days"
            [required]="false"
            [min]="0">
          </pdq-input-arrows>
          <pdq-input-arrows
            [tooltip]="runningABTest ? 'Disabled due running A/B test' : ''"
            tooltipIconColor="var(--warning-default)"
            width="275"
            widthSize="auto"
            [disabled]="runningABTest"
            placeholder="Enter max # of {{ getDeliveryPromiseDisplayTimeString() }}"
            formControlName="maxTransitDays"
            label="Max transit days"
            [required]="false"
            [min]="0">
          </pdq-input-arrows>
        </div>
        @if (formGroup.errors?.delivery_promise_transittime_missmatch) {
          <span class="inline-error"> *{{ formGroup.errors?.delivery_promise_transittime_missmatch_msg }} </span>
        }

        <div class="flex-row" style="margin-top: 20px">
          <pdq-slide-toggle
            formControlName="combineConsecutiveDays"
            [fullWidth]="true"
            [label]="'Consecutive Days Logic'"
            [subtext]="'Delivery estimated is calculated based on consecutive business days (processing + transit), skipping holidays and non-business days.\nIf no consecutive business days range is found, the fallback text will be displayed'">
            <pdq-icon
              label-addon
              icon="more_information"
              [matTooltip]="'Maximum range to find consecutive business days is 30 days. If not found within this range, the fallback text will be displayed.'"
              matTooltipClass="pdq-mat-tooltip"></pdq-icon>
          </pdq-slide-toggle>
        </div>
        @if (formGroup.errors?.delivery_promise_restriction_missmatch) {
          <span class="inline-error"> *{{ formGroup.errors?.delivery_promise_restriction_missmatch_msg }} </span>
        }
      }
    } @else if (shippingMethodCategory === 'local') {
      <div class="transit-text">Transit</div>
      <div class="flex-row">
        <pdq-input-arrows
          [tooltip]="runningABTest ? 'Disabled due running A/B test' : ''"
          tooltipIconColor="var(--warning-default)"
          width="275"
          widthSize="auto"
          [disabled]="runningABTest"
          placeholder="{{ getDeliveryPromiseInputPlaceholder() }}"
          formControlName="minHours"
          label="Minimum {{ shippingMethodCategory | dpInputTitle: estimatedTimeConversions }}"
          [required]="false"
          [min]="0">
        </pdq-input-arrows>
        <pdq-input-arrows
          [tooltip]="runningABTest ? 'Disabled due running A/B test' : ''"
          tooltipIconColor="var(--warning-default)"
          width="275"
          widthSize="auto"
          [disabled]="runningABTest"
          placeholder="Enter max # of {{ getDeliveryPromiseDisplayTimeString() }}"
          formControlName="maxHours"
          label="Maximum {{ shippingMethodCategory | dpInputTitle: estimatedTimeConversions }}"
          [required]="false"
          [min]="0">
        </pdq-input-arrows>
      </div>
      @if (formGroup.errors?.delivery_promise_hours_missmatch) {
        <span class="inline-error"> *{{ formGroup.errors?.delivery_promise_hours_missmatch_msg }} </span>
      }
    }
  </div>
</form>
